import { render, staticRenderFns } from "./DiffPopup.vue?vue&type=template&id=716c6fe0&"
import script from "./DiffPopup.vue?vue&type=script&lang=js&"
export * from "./DiffPopup.vue?vue&type=script&lang=js&"
import style0 from "./DiffPopup.vue?vue&type=style&index=0&id=716c6fe0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports